import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

/**
 * Loading indicator for chat messages
 * Currently shows shimmering "Generating..." text; original SVG kept commented.
 */
const MessageLoading = ({ className = '' }) => {
  const { theme } = useTheme();

  // Define keyframes inline
  const shimmerKeyframes = `
  @keyframes shimmerText {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  `;

  const gradient = theme === 'dark'
    ? 'linear-gradient(90deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.08) 100%)'
    : 'linear-gradient(90deg, rgba(0,0,0,0.12) 0%, rgba(0,0,0,0.55) 50%, rgba(0,0,0,0.12) 100%)';

  const shimmerStyle = {
    display: 'inline-block',
    backgroundImage: gradient,
    backgroundSize: '200% 100%',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    animation: 'shimmerText 1.6s linear infinite',
  };

  return (
    <div className={`flex items-center justify-start space-x-3 leading-none my-0 py-0 ${className}`} style={{ marginTop: 0, paddingTop: 0 }}>
      {/* Inline keyframes for shimmer */}
      <style>{shimmerKeyframes}</style>
      <span className="text-sm" style={shimmerStyle}>Generating...</span>
      {/*
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-accent-foreground"
      >
        <circle cx="4" cy="12" r="2" fill="currentColor">
          <animate
            id="spinner_qFRN"
            begin="0;spinner_OcgL.end+0.25s"
            attributeName="cy"
            calcMode="spline"
            dur="0.6s"
            values="12;6;12"
            keySplines=".33,.66,.66,1;.33,0,.66,.33"
          />
        </circle>
        <circle cx="12" cy="12" r="2" fill="currentColor">
          <animate
            begin="spinner_qFRN.begin+0.15s"
            attributeName="cy"
            calcMode="spline"
            dur="0.6s"
            values="12;6;12"
            keySplines=".33,.66,.66,1;.33,0,.66,.33"
          />
        </circle>
        <circle cx="20" cy="12" r="2" fill="currentColor">
          <animate
            id="spinner_OcgL"
            begin="spinner_qFRN.begin+0.2s"
            attributeName="cy"
            calcMode="spline"
            dur="0.6s"
            values="12;6;12"
            keySplines=".33,.66,.66,1;.33,0,.66,.33"
          />
        </circle>
      </svg>
      */}
    </div>
  );
};

export default MessageLoading;